import { useDispatch, useSelector } from 'react-redux';
import Properties from 'redux/Properties';
import Fields from 'redux/Fields';
import { AuthContext } from 'context/AuthContext';
import { useContext } from 'react';

import Notifications from 'redux/Notifications';

const useProperties = () => {
  const dispatch = useDispatch();

  const isFetchingProperties = useSelector(Properties.getIsFetchingProperties);

  const selectedProperty = useSelector(Properties.getActiveProperty);
  const selectedPropertyId = useSelector(Properties.getActivePropertyId);
  const propertyBounds = useSelector(Properties.getPropertyBounds);
  const properties = useSelector(Properties.getProperties);
  const userProperties = useSelector(Properties.getUserProperties);
  const orgProperties = useSelector(Properties.getOrgProperties);
  const { user } = useContext(AuthContext);

  const fetchProperties = (organizationId, userId = user.id) => {
    if (!isFetchingProperties) {
      return dispatch(Properties.fetchProperties(organizationId, userId)).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const fetchUserProperties = (organizationId, userId) => {
    if (userId.length === 0) {
      userId = user.id;
    }
    if (!isFetchingProperties) {
      return dispatch(Properties.fetchUserProperties(organizationId, userId)).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const saveProperty = (property) => {
    if (property.id) {
      return dispatch(Properties.updateProperty(property)).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
    return dispatch(Properties.createProperty(property)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const setSelectedProperty = (propertyId) => {
    return dispatch(Properties.setSelectedProperty(propertyId));
  };

  const deleteProperty = (property) => {
    dispatch(Properties.deleteProperty(property))
      .then(() => {
        dispatch(Fields.startFetchFields());
        dispatch(Fields.fetchFields());
      })
      .catch((err) => {
        dispatch(Notifications.setError(err));
      });
  };

  const deleteUserProperty = (userId, propertyId) => {
    dispatch(Properties.deleteUserProperty(userId, propertyId)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const createUserProperty = (userProperty) => {
    dispatch(Properties.createUserProperty(userProperty)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  return {
    properties,
    userProperties,
    selectedProperty,
    selectedPropertyId,
    isFetchingProperties,
    propertyBounds,
    orgProperties,

    setSelectedProperty,
    saveProperty,
    deleteProperty,
    deleteUserProperty,
    createUserProperty,
    fetchProperties,
    fetchUserProperties,
  };
};

export default useProperties;
